import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab } from "@pentabd/ui";
import { Priority, Status } from ".";

const SettingsBody = () => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const handleActiveTab = (tabIndex: number) => setCurrentTab(tabIndex);

  return (
    <div className="py-10">
      <Tab active={currentTab} setActiveTab={handleActiveTab}>
        <Tab.Heads>
          <Tab.Item index={0} label={t("TM_SETTINGS.TABS.STATUS")} />
          <Tab.Item index={1} label={t("TM_SETTINGS.TABS.PRIORITY")} />
        </Tab.Heads>
        <Tab.ContentWrapper>
          <Tab.Content index={0}>
            <Status />
          </Tab.Content>
          <Tab.Content index={1}>
            <Priority />
          </Tab.Content>
        </Tab.ContentWrapper>
      </Tab>
    </div>
  );
};

export default SettingsBody;
